module.exports = __webpack_public_path__ + "img/question15c1.ce9f7af6.png";